import { NotificationScope } from 'generated/graphql'

export type menuType = 'all' | 'activity' | 'channel' | 'community' | 'chat'

export const menuToScope = {
  all: NotificationScope.NOTIFICATION,
  activity: NotificationScope.ACTIVITY_NOTIFICATION,
  channel: NotificationScope.CHANNEL_NOTIFICATION,
  community: NotificationScope.COMMUNITY_NOTIFICATION,
  chat: NotificationScope.CHAT_NOTIFICATION,
} as const
